/* MOX MOX · Playroom – theme behaviour (vanilla, no dependencies) */
(function () {
  'use strict';

  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function money(cents) {
    var v = Math.round(cents) / 100;
    if (v === 1) return '1 leu';
    var whole = Math.floor(Math.abs(v));
    var dec = Math.round((Math.abs(v) - whole) * 100);
    var s = String(whole).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    if (dec) s += ',' + (dec < 10 ? '0' : '') + dec;
    return (v < 0 ? '-' : '') + s + ' lei';
  }

  /* ---------------- toast ---------------- */
  var toastTimer;
  function toast(msg, isError) {
    var t = $('[data-mox-toast]');
    if (!t) { if (isError) window.alert(msg); return; }
    $('[data-mox-toast-msg]', t).textContent = msg;
    t.classList.toggle('is-err', !!isError);
    t.classList.add('is-on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove('is-on'); }, isError ? 5000 : 4000);
  }

  /* ---------------- cart ---------------- */
  function setCartCount(n) {
    $$('[data-mox-cart-count]').forEach(function (el) {
      el.textContent = n;
      if (el.classList.contains('mox-dotcount')) el.hidden = n === 0;
    });
    $$('.mox-cartbtn').forEach(function (a) { a.setAttribute('aria-label', 'Coș, ' + n + ' produse'); });
  }
  function refreshCart() {
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        setCartCount(cart.item_count);
        document.dispatchEvent(new CustomEvent('mox:cart', { detail: cart }));
        return cart;
      });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('form[data-mox-atc]')) return;
    e.preventDefault();
    var btns = $$('[type="submit"]', form).concat(form.id ? $$('[form="' + form.id + '"][type="submit"]') : []);
    btns.forEach(function (b) { b.disabled = true; b.classList.add('is-loading'); });
    var fd = new FormData(form);
    var ids = cartSectionIds();
    if (ids.length) {
      fd.append('sections', ids.join(','));
      fd.append('sections_url', window.location.pathname);
    }
    fetch(root + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: fd })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.d.description || res.d.message || 'Nu am putut adăuga produsul în coș.');
        var title = res.d.product_title || 'Produsul';
        if (res.d.sections) applyCartSections(res.d.sections);
        return refreshCart().then(function () {
          var d = cartDrawer();
          if (d && !document.querySelector('[data-mox-cart-page]')) openDrawer(d);
          else toast('„' + title + '” e în coș.');
        });
      })
      .catch(function (err) { toast(err.message, true); })
      .then(function () {
        btns.forEach(function (b) {
          b.classList.remove('is-loading');
          if (!b.hasAttribute('data-mox-soldout')) b.disabled = false;
        });
      });
  });

  /* ---------------- cart drawer + cart page (Playroom) ---------------- */
  function cartDrawer() { return document.querySelector('[data-mox-drawer="cart"]'); }
  function cartSectionIds() {
    return $$('[data-mox-cart-section]').map(function (el) { return el.getAttribute('data-mox-cart-section'); });
  }
  function applyCartSections(sections) {
    Object.keys(sections || {}).forEach(function (id) {
      var html = sections[id];
      if (!html) return;
      var host = document.querySelector('[data-mox-cart-section="' + id + '"]');
      if (!host) return;
      var tmp = document.createElement('div');
      tmp.innerHTML = html;
      var fresh = tmp.querySelector('[data-mox-cart-body]');
      var old = host.querySelector('[data-mox-cart-body]');
      if (fresh && old) old.replaceWith(fresh);
    });
  }
  function reloadCartSections() {
    var ids = cartSectionIds();
    if (!ids.length) return Promise.resolve();
    return fetch(window.location.pathname + '?sections=' + ids.join(','))
      .then(function (r) { return r.json(); })
      .then(applyCartSections)
      .catch(function () { /* keep current markup */ });
  }
  var cartBusy = false;
  function changeLine(key, qty) {
    if (cartBusy) return;
    cartBusy = true;
    $$('[data-mox-cart-body]').forEach(function (b) { b.classList.add('is-busy'); });
    var ids = cartSectionIds();
    fetch(root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: Math.max(0, qty), sections: ids.join(','), sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.d.description || res.d.message || 'Nu am putut actualiza coșul.');
        if (res.d.sections) applyCartSections(res.d.sections);
        setCartCount(res.d.item_count);
        document.dispatchEvent(new CustomEvent('mox:cart', { detail: res.d }));
      })
      .catch(function (err) { toast(err.message, true); reloadCartSections(); })
      .then(function () {
        cartBusy = false;
        $$('[data-mox-cart-body]').forEach(function (b) { b.classList.remove('is-busy'); });
      });
  }
  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-mox-cart-open]');
    if (open) {
      var d = cartDrawer();
      if (!d || document.querySelector('[data-mox-cart-page]')) return;
      e.preventDefault();
      openDrawer(d);
      reloadCartSections();
      return;
    }
    var q = e.target.closest('[data-mox-cart-qty]');
    if (q) {
      e.preventDefault();
      changeLine(q.getAttribute('data-key'), parseInt(q.getAttribute('data-mox-cart-qty'), 10) || 0);
      return;
    }
    var co = e.target.closest('[data-mox-checkout]');
    if (co) {
      var body = co.closest('[data-mox-cart-body]');
      var terms = body && $('[data-mox-terms]', body);
      if (terms && !terms.checked) {
        e.preventDefault();
        toast('Bifează acordul cu Termenii și condițiile ca să continui.', true);
        terms.focus();
      }
    }
  });
  document.addEventListener('change', function (e) {
    var inp = e.target.closest('[data-mox-cart-input]');
    if (!inp) return;
    changeLine(inp.getAttribute('data-key'), parseInt(inp.value, 10) || 0);
  });

  /* ---------------- drawers (menu, favourites, filters) ---------------- */
  var lastFocus = null;
  function openDrawer(el) {
    if (!el) return;
    lastFocus = document.activeElement;
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('mox-lock');
    var f = $('button, a, input', el.querySelector('.mox-drawer__panel') || el);
    if (f) setTimeout(function () { f.focus(); }, 50);
  }
  function closeDrawers() {
    $$('.mox-drawer.is-open, .mox-filters.is-open').forEach(function (el) {
      el.classList.remove('is-open');
      if (el.classList.contains('mox-drawer')) el.setAttribute('aria-hidden', 'true');
    });
    $$('[data-mox-filters-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    document.documentElement.classList.remove('mox-lock');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-mox-open]');
    if (opener) {
      var which = opener.getAttribute('data-mox-open');
      if (which === 'search') {
        var ms = $('[data-mox-msearch]');
        if (ms) {
          e.preventDefault();
          ms.hidden = !ms.hidden;
          if (!ms.hidden) { var i = $('input[type="search"]', ms); if (i) i.focus(); }
        }
        return;
      }
      e.preventDefault();
      if (which === 'fav') renderFavs();
      openDrawer($('[data-mox-drawer="' + which + '"]'));
      return;
    }
    if (e.target.closest('[data-mox-close], [data-mox-filters-close]')) { e.preventDefault(); closeDrawers(); return; }
    var fopen = e.target.closest('[data-mox-filters-open]');
    if (fopen) {
      var panel = document.getElementById(fopen.getAttribute('aria-controls'));
      if (panel) {
        lastFocus = fopen;
        panel.classList.add('is-open');
        fopen.setAttribute('aria-expanded', 'true');
        document.documentElement.classList.add('mox-lock');
      }
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawers(); });

  /* ---------------- favourites (localStorage) ---------------- */
  var FKEY = 'mox-fav';
  function getFavs() { try { return JSON.parse(localStorage.getItem(FKEY)) || []; } catch (err) { return []; } }
  function setFavs(list) { try { localStorage.setItem(FKEY, JSON.stringify(list)); } catch (err) { /* storage blocked */ } syncFavs(); }
  function syncFavs() {
    var list = getFavs();
    var handles = list.map(function (f) { return f.handle; });
    $$('[data-mox-fav]').forEach(function (b) {
      var on = handles.indexOf(b.getAttribute('data-mox-fav')) > -1;
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      b.setAttribute('aria-label', on ? 'Scoate de la favorite' : 'Adaugă la favorite');
    });
    $$('[data-mox-fav-count]').forEach(function (c) { c.textContent = list.length; c.hidden = list.length === 0; });
  }
  function esc(s) { return String(s || '').replace(/[&<>"']/g, function (ch) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch]; }); }
  function renderFavs() {
    var box = $('[data-mox-fav-list]');
    if (!box) return;
    var list = getFavs();
    var empty = $('[data-mox-fav-empty]');
    if (empty) empty.hidden = list.length > 0;
    box.innerHTML = list.map(function (f) {
      return '<div class="mox-fav__row" style="display:flex;align-items:center;gap:8px">' +
        '<a class="mox-fav__item" href="' + esc(f.url) + '">' +
        (f.img ? '<img src="' + esc(f.img) + '" alt="" width="72" height="72" loading="lazy">' : '') +
        '<span><span class="mox-fav__name">' + esc(f.title) + '</span><span class="mox-fav__price" style="display:block">' + esc(f.price) + '</span></span></a>' +
        '<button type="button" class="mox-iconbtn mox-fav__rm" aria-label="Scoate ' + esc(f.title) + ' de la favorite" data-mox-fav-rm="' + esc(f.handle) + '">' +
        '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"></path></svg></button></div>';
    }).join('');
  }
  document.addEventListener('click', function (e) {
    var rm = e.target.closest('[data-mox-fav-rm]');
    if (rm) {
      var h = rm.getAttribute('data-mox-fav-rm');
      setFavs(getFavs().filter(function (f) { return f.handle !== h; }));
      renderFavs();
      return;
    }
    var b = e.target.closest('[data-mox-fav]');
    if (!b) return;
    e.preventDefault();
    var handle = b.getAttribute('data-mox-fav');
    var list = getFavs();
    var idx = -1;
    list.forEach(function (f, i) { if (f.handle === handle) idx = i; });
    if (idx > -1) {
      list.splice(idx, 1);
      toast('Am scos produsul de la favorite.');
    } else {
      list.unshift({ handle: handle, title: b.getAttribute('data-title'), url: b.getAttribute('data-url'), img: b.getAttribute('data-img'), price: b.getAttribute('data-price') });
      toast('Salvat la favorite.');
    }
    setFavs(list.slice(0, 60));
  });

  /* ---------------- copy discount code ---------------- */
  document.addEventListener('click', function (e) {
    var c = e.target.closest('[data-mox-copy]');
    if (!c) return;
    var code = c.getAttribute('data-mox-copy');
    var done = function () { toast('Codul ' + code + ' e copiat. Îl lipești la finalizarea comenzii.'); };
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(code).then(done, done);
    else done();
  });

  /* ---------------- copy article link ---------------- */
  document.addEventListener('click', function (e) {
    var c = e.target.closest('[data-mox-copylink]');
    if (!c) return;
    var url = c.getAttribute('data-mox-copylink');
    var ok = function () { toast('Linkul e copiat. Îl poți trimite mai departe.'); };
    var fail = function () { toast('Nu am putut copia linkul: îl găsești în bara de adrese.'); };
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(url).then(ok, fail);
    else fail();
  });

  /* ---------------- product page ---------------- */
  function initProduct(pdp) {
    var form = $('form[data-mox-atc]', pdp);
    var dataEl = pdp.parentNode.querySelector('[data-mox-variants]') || $('[data-mox-variants]');
    var variants = [];
    try { variants = JSON.parse(dataEl.textContent); } catch (err) { variants = []; }
    var idInput = $('[data-mox-variant-id]', pdp);
    var qtyInput = $('[data-mox-qty-input]', pdp);
    var threshold = parseInt(pdp.getAttribute('data-threshold'), 10) || 30000;
    var cartTotal = parseInt(pdp.getAttribute('data-cart-total'), 10) || 0;
    var mainImg = $('.mox-gal__img', pdp);
    var stock = $('[data-mox-stock]', pdp);

    function current() {
      var id = idInput ? parseInt(idInput.value, 10) : 0;
      for (var i = 0; i < variants.length; i++) if (variants[i].id === id) return variants[i];
      return variants[0];
    }

    function updateShipping() {
      var v = current();
      if (!v) return;
      var qty = Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1);
      var total = cartTotal + v.price * qty;
      var remaining = threshold - total;
      var msg = $('[data-mox-ship-msg]', pdp);
      var bar = $('[data-mox-ship-bar]', pdp);
      if (msg) msg.textContent = remaining > 0 ? 'Mai adaugă ' + money(remaining) + ' și livrarea e gratuită' : 'Livrarea e gratuită pentru comanda ta';
      if (bar) bar.style.width = Math.min(100, Math.round(total * 100 / threshold)) + '%';
    }

    function setImageById(mediaId) {
      if (!mediaId) return;
      var t = $('[data-mox-thumb][data-media-id="' + mediaId + '"]', pdp);
      if (t) t.click();
    }

    function updateVariant(v) {
      if (!v) return;
      if (idInput) idInput.value = v.id;
      $$('[data-mox-price]').forEach(function (p) { p.textContent = money(v.price); });
      var cmp = $('[data-mox-compare]', pdp);
      if (cmp) { cmp.hidden = !(v.compare > v.price); cmp.textContent = money(v.compare); }
      var label = v.available ? 'Adaugă în coș' : 'Stoc epuizat';
      $$('[data-mox-atc-btn]').forEach(function (b) {
        b.textContent = label;
        b.disabled = !v.available;
        if (v.available) b.removeAttribute('data-mox-soldout'); else b.setAttribute('data-mox-soldout', '');
      });
      if (stock) {
        var low = parseInt(stock.getAttribute('data-low'), 10) || 10;
        var cls = 'is-ok', txt = stock.getAttribute('data-ok-text') || 'În stoc';
        if (!v.available) { cls = 'is-out'; txt = 'Stoc epuizat'; }
        else if (v.managed && v.qty <= low) { cls = 'is-low'; txt = 'Stoc redus: mai sunt doar ' + v.qty; }
        stock.className = 'mox-stock ' + cls;
        $('[data-mox-stock-text]', stock).textContent = txt;
      }
      var sku = $('[data-mox-sku]', pdp);
      if (sku && v.sku) sku.textContent = v.sku;
      setImageById(v.media);
      if (window.history && window.history.replaceState) {
        var u = new URL(window.location.href);
        u.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', u.toString());
      }
      markAvailability();
      updateShipping();
    }

    function selectedOptions() {
      return $$('[data-mox-opt]', pdp).map(function (fs) {
        var c = $('input:checked', fs);
        return c ? c.value : null;
      });
    }

    function markAvailability() {
      var sel = selectedOptions();
      $$('[data-mox-opt]', pdp).forEach(function (fs, oi) {
        $$('.mox-opt__val', fs).forEach(function (lab) {
          var val = $('input', lab).value;
          var ok = variants.some(function (v) {
            if (!v.available || v.options[oi] !== val) return false;
            for (var k = 0; k < sel.length; k++) { if (k !== oi && sel[k] !== null && v.options[k] !== sel[k]) return false; }
            return true;
          });
          lab.classList.toggle('is-na', !ok);
        });
        var s = $('[data-mox-opt-sel]', fs);
        if (s) s.textContent = sel[oi] || '';
      });
    }

    pdp.addEventListener('change', function (e) {
      if (!e.target.closest('[data-mox-opt]')) return;
      var sel = selectedOptions();
      var match = null;
      variants.forEach(function (v) {
        if (match) return;
        var ok = v.options.every(function (o, i) { return sel[i] === null || o === sel[i]; });
        if (ok) match = v;
      });
      if (match) updateVariant(match);
    });

    pdp.addEventListener('click', function (e) {
      var q = e.target.closest('[data-mox-qty]');
      if (q && qtyInput) {
        var n = (parseInt(qtyInput.value, 10) || 1) + parseInt(q.getAttribute('data-mox-qty'), 10);
        qtyInput.value = Math.max(1, n);
        updateShipping();
        return;
      }
      var t = e.target.closest('[data-mox-thumb]');
      if (t && mainImg) {
        mainImg.src = t.getAttribute('data-src');
        mainImg.srcset = t.getAttribute('data-srcset');
        $$('[data-mox-thumb]', pdp).forEach(function (x) { x.classList.toggle('is-active', x === t); });
      }
    });
    if (qtyInput) qtyInput.addEventListener('input', updateShipping);

    document.addEventListener('mox:cart', function (e) { cartTotal = e.detail.total_price; updateShipping(); });

    markAvailability();

    /* sticky add-to-cart */
    var sticky = $('[data-mox-sticky]');
    var anchor = $('.mox-buy', pdp);
    if (sticky && anchor && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        var e = entries[0];
        var show = !e.isIntersecting && e.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        $$('button', sticky).forEach(function (b) { b.tabIndex = show ? 0 : -1; });
        document.body.classList.toggle('mox-sticky-on', show);
      });
      io.observe(anchor);
    }
  }

  /* ---------------- recommendations ---------------- */
  function initReco(sec) {
    var url = sec.getAttribute('data-url');
    if (!url || sec.children.length) return;
    fetch(url).then(function (r) { return r.text(); }).then(function (html) {
      var tmp = document.createElement('div');
      tmp.innerHTML = html;
      var fresh = tmp.querySelector('[data-mox-reco]');
      if (fresh && fresh.innerHTML.trim()) { sec.innerHTML = fresh.innerHTML; syncFavs(); }
    }).catch(function () { /* silent */ });
  }

  /* ---------------- reviews CTA (Judge.me) ---------------- */
  document.addEventListener('click', function (e) {
    var w = e.target.closest('[data-mox-write-review]');
    if (!w) return;
    var link = document.querySelector('.jdgm-write-rev-link, .jdgm-rev-widg__write-rev-link, [class*="write-rev"]');
    if (link) link.click();
    var apps = document.querySelector('.mox-revs__apps');
    if (apps) setTimeout(function () { apps.scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 120);
  });

  /* ---------------- collection: filters, sort, load more ---------------- */
  function initCollection(c) {
    var form = $('[data-mox-filter-form]', c);
    var timer;
    function submit() {
      if (!form) return;
      var fd = new FormData(form);
      var params = new URLSearchParams();
      fd.forEach(function (v, k) { if (v !== '') params.append(k, v); });
      window.location.href = form.getAttribute('action') + '?' + params.toString();
    }
    if (form) {
      form.addEventListener('change', function (e) {
        if (window.matchMedia('(max-width: 749px)').matches) return; /* mobile: apply with the button */
        clearTimeout(timer);
        timer = setTimeout(submit, e.target.type === 'number' ? 600 : 50);
      });
      form.addEventListener('submit', function (e) { e.preventDefault(); submit(); });
    }
    var sort = $('[data-mox-sort]', c);
    if (sort) sort.addEventListener('change', function () {
      if (form) {
        var h = $('input[name="sort_by"]', form);
        if (h) h.value = sort.value;
        submit();
      } else {
        var u = new URL(window.location.href);
        u.searchParams.set('sort_by', sort.value);
        window.location.href = u.toString();
      }
    });

    c.addEventListener('click', function (e) {
      var more = e.target.closest('[data-mox-loadmore]');
      if (!more) return;
      e.preventDefault();
      var href = more.getAttribute('href');
      var sid = c.getAttribute('data-section');
      more.classList.add('is-loading');
      more.textContent = 'Se încarcă…';
      var u = new URL(href, window.location.origin);
      u.searchParams.set('section_id', sid);
      fetch(u.toString()).then(function (r) { return r.text(); }).then(function (html) {
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var grid = $('[data-mox-grid]', c);
        $$('[data-mox-item]', tmp).forEach(function (it) { grid.appendChild(it); });
        var seenNew = $('[data-mox-seen]', tmp);
        var barNew = $('[data-mox-bar]', tmp);
        if (seenNew) $('[data-mox-seen]', c).textContent = seenNew.textContent;
        if (barNew) $('[data-mox-bar]', c).style.width = barNew.style.width;
        var nextMore = $('[data-mox-loadmore]', tmp);
        if (nextMore) {
          more.setAttribute('href', nextMore.getAttribute('href'));
          more.textContent = 'Încarcă mai multe';
          more.classList.remove('is-loading');
        } else {
          more.remove();
        }
        syncFavs();
      }).catch(function () { window.location.href = href; });
    });
  }

  /* ---------------- boot ---------------- */
  function boot() {
    document.documentElement.classList.remove('no-js');
    syncFavs();
    $$('[data-mox-pdp]').forEach(initProduct);
    $$('[data-mox-reco]').forEach(initReco);
    $$('[data-mox-coll]').forEach(initCollection);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  /* theme editor: re-init sections when they are re-rendered */
  document.addEventListener('shopify:section:load', function (e) {
    syncFavs();
    $$('[data-mox-pdp]', e.target).forEach(initProduct);
    $$('[data-mox-reco]', e.target).forEach(initReco);
    $$('[data-mox-coll]', e.target).forEach(initCollection);
  });
})();
